import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Content } from '../../components/Content';
import { useHistory } from 'react-router-dom';
/* Componentes */
import { Loading } from '../../components/Loading';
import FURGAPI from '../../services/api.furg';
import { getToken } from '../../services/auth';

const Habilitacao = () => {
    const { vestibular } = useParams();
    const history = useHistory();
    const [candidato, setCandidato] = useState({});
    const [periodos, setPeriodos] = useState([]);
    const [periodoVigente, setPeriodoVigente] = useState({});
    const [loading, setLoading] = useState(true);

    const loadDadosHabilitacao = useCallback(async () => {
        const token = getToken(vestibular);
        setLoading(true);
        try {
            const dadosCandidato = await FURGAPI.call('sischamamentos/Publico/obtemDadosCandidato', { token });
            setCandidato(dadosCandidato);

            const datas = await FURGAPI.call('sischamamentos/Publico/obtemPeriodoHabilitacaoVigente', { token });
            setPeriodos(datas);
        } catch (error) {}
        setLoading(false);
    }, [vestibular]);

    useEffect(() => {
        if (candidato.chamamento === '1') {
            history.push(`/documentos/${vestibular}`);
        }
    }, [candidato.chamamento, history, vestibular]);

    useEffect(() => {
        loadDadosHabilitacao();
    }, [loadDadosHabilitacao, vestibular]);

    useEffect(() => {
        if (periodos.length === 0) {
            return;
        }
        const periodo = periodos.filter(datas => {
            return datas.vigente === 't';
        });
        setPeriodoVigente(periodo[0] ?? {});
    }, [periodos]);

    const habilitarParticipacao = () => {
        const token = getToken(vestibular);
        setLoading(true);

        FURGAPI.call('sischamamentos/Publico/habilitarCandidato', { token })
            .then(resposta => {
                loadDadosHabilitacao();
                setLoading(false);
            })
            .catch(err => setLoading(false));
    };
    const estaVigente = periodoVigente?.dt_inicial;
    const estaHabilitado = candidato.dataHabilitacao;

    if (loading) {
        return <Loading />;
    }

    return (
        <Content title="Habilitação" subtitle={`Aqui você deve habilitar sua participação no Processo Seletivo ${candidato.ds_vestibular}`}>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-body">
                        <p>
                            <strong>{estaVigente ? `Período de habilitação vigente de ${periodoVigente.dt_inicial} à ${periodoVigente.dt_final}` : `Período fechado para habilitação`}</strong>
                        </p>

                        <div>
                            <strong>Nome: </strong>
                            {candidato.nome}
                        </div>

                        {estaHabilitado && (
                            <p className="mt-3 alert alert-success mb-0 mt-3">
                                Você já está habilitado para concorrer as vagas da lista de espera da FURG para o processo seletivo <strong>{candidato.ds_vestibular}</strong>.
                                <br />
                                Sua habilitação foi realizada em <strong>{candidato.dataHabilitacao}</strong>.
                                <br />
                                {candidato.chamamento === null && `Aguarde sua convocação, para o envio da documentação da solicitação de matrícula.`}
                            </p>
                        )}

                        {!estaHabilitado &&
                            (estaVigente ? (
                                <>
                                    <p className="mt-3 alert alert-warning mb-0 mt-3">
                                        Você não está habilitado para concorrer as vagas da lista de espera da FURG para o processo seletivo <strong>{candidato.ds_vestibular}</strong>, para realizar
                                        sua habilitação, conforme exigência do edital do processo, clique no botão <strong>habilitar participação</strong> logo abaixo.
                                    </p>
                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', columnGap: 10 }}>
                                        <button type="button" className="btn btn-primary btn-block mt-3 btn-lg" onClick={habilitarParticipacao}>
                                            Habilitar participação
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <p className="alert alert-warning mb-0 mt-3">
                                    {' '}
                                    Você não está habilitado para concorrer as vagas da lista de espera da FURG para o processo seletivo <strong>{candidato.ds_vestibular}</strong>. No momento não é
                                    possível realizar a habilitação, pois o período está fechado.
                                </p>
                            ))}
                    </div>
                </div>
            </div>
        </Content>
    );
};

export default Habilitacao;
